import { FC } from "react"
import MainLayout from "./MainLayout"

export const PrivateHomePage: FC = () => {
  return <MainLayout>hello private</MainLayout>
}

export default PrivateHomePage
